var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],class:{'button--loading': _vm.loading}},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }